import store from '../../../store';
import { PLENARY, COMMITTEE } from '..';

export default sourceSession => {
	const type = sourceSession.MODEL === store.model.PlenarySession ? PLENARY : COMMITTEE;
	const foreignKey = type === PLENARY ? 'plenarySessionId' : 'committeeSessionId';
	return { type, foreignKey };
}
